/**
 * Product card quick add-to-cart stepper.
 *
 * Shows a - / qty / + control in place of the price when a card is hovered.
 * The control stays visible while the product is in the cart, and hides again
 * once its quantity drops back to zero.
 *
 * Quantities are written with /cart/update.js, which sets an absolute quantity
 * per variant, so rapid clicking cannot drift out of sync with the real cart.
 */
(function () {
  'use strict';

  var IN_CART_CLASS = 'pb-atc-in-cart';
  var FLUSH_DELAY = 350;

  var routes = (window.theme && window.theme.routes) || {};
  var cartRoot = routes.cart_url || '/cart';
  var cartUrl = cartRoot + '.js';
  var updateUrl = cartRoot + '/update.js';

  var cartQty = {}; // variantId (string) -> quantity in cart
  var pending = {}; // variantId (string) -> quantity we still need to send
  var flushTimer = null;

  function steppers() {
    return document.querySelectorAll('[data-pb-atc]');
  }

  function renderHeaderCount(count) {
    if (typeof count !== 'number') return;
    var nodes = document.querySelectorAll('.header-cart__count');
    for (var i = 0; i < nodes.length; i++) {
      nodes[i].textContent = count;
    }
  }

  function render() {
    var nodes = steppers();
    for (var i = 0; i < nodes.length; i++) {
      var stepper = nodes[i];
      var id = stepper.getAttribute('data-pb-atc-variant');
      var qty = cartQty[id] || 0;
      var card = stepper.closest('.product-block');

      var qtyNode = stepper.querySelector('[data-pb-atc-qty]');
      if (qtyNode) qtyNode.textContent = qty;

      var minus = stepper.querySelector('[data-pb-atc-minus]');
      if (minus) minus.disabled = qty === 0;

      if (card) card.classList.toggle(IN_CART_CLASS, qty > 0);
    }
  }

  function syncFromCart(cart) {
    if (!cart || !cart.items) return;
    cartQty = {};
    for (var i = 0; i < cart.items.length; i++) {
      var item = cart.items[i];
      var key = String(item.variant_id);
      cartQty[key] = (cartQty[key] || 0) + item.quantity;
    }
    render();
    renderHeaderCount(cart.item_count);
  }

  function loadCart() {
    return fetch(cartUrl, { credentials: 'same-origin' })
      .then(function (res) { return res.json(); })
      .then(syncFromCart)
      .catch(function () { /* leave the UI at its last known state */ });
  }

  function flush() {
    var updates = pending;
    pending = {};
    if (!Object.keys(updates).length) return;

    fetch(updateUrl, {
      method: 'POST',
      credentials: 'same-origin',
      headers: {
        'Content-Type': 'application/json',
        Accept: 'application/json'
      },
      body: JSON.stringify({ updates: updates })
    })
      .then(function (res) { return res.json(); })
      .then(function (cart) {
        syncFromCart(cart);
        document.dispatchEvent(new CustomEvent('pb:cart-changed'));
      })
      .catch(function () {
        // Network or validation error (e.g. more stock requested than exists) --
        // fall back to whatever the cart actually holds.
        loadCart();
      });
  }

  function setQty(id, qty) {
    if (qty < 0) qty = 0;
    cartQty[id] = qty;
    pending[id] = qty;
    render();
    clearTimeout(flushTimer);
    flushTimer = setTimeout(flush, FLUSH_DELAY);
  }

  document.addEventListener('click', function (evt) {
    var target = evt.target;
    if (!target || typeof target.closest !== 'function') return;

    var button = target.closest('[data-pb-atc-plus], [data-pb-atc-minus]');
    if (!button) return;

    var stepper = button.closest('[data-pb-atc]');
    if (!stepper) return;

    evt.preventDefault();
    evt.stopPropagation();

    var id = stepper.getAttribute('data-pb-atc-variant');
    var current = cartQty[id] || 0;
    setQty(id, button.hasAttribute('data-pb-atc-plus') ? current + 1 : current - 1);
  });

  function applyVariantChoice(picker, id, label) {
    picker.setAttribute('data-pb-atc-variant', id);
    picker.classList.toggle('is-variant-chosen', id !== '');

    var labelNode = picker.querySelector('[data-pb-variant-label]');
    if (labelNode && label) labelNode.textContent = label;

    var control = picker.querySelector('.pb-atc__control');
    if (control) {
      if (id) {
        control.removeAttribute('hidden');
      } else {
        control.setAttribute('hidden', 'hidden');
      }
    }

    var toggle = picker.querySelector('[data-pb-variant-toggle]');
    if (toggle) toggle.blur();

    render();
  }

  function pickerForList(list) {
    var id = list.getAttribute('data-pb-for');
    if (id) return document.querySelector('[data-pb-variant-picker][data-pb-product="' + id + '"]');
    return list.closest('[data-pb-variant-picker]');
  }

  function closeVariantLists(except) {
    var lists = document.querySelectorAll('[data-pb-variant-list]');
    for (var i = 0; i < lists.length; i++) {
      var list = lists[i];
      if (except && list === except) continue;
      list.hidden = true;
      list.style.cssText = '';
      if (list._originParent && list.parentNode !== list._originParent) {
        list._originParent.appendChild(list);
      }
      var picker = pickerForList(list);
      if (picker) picker.classList.remove('is-variant-open');
      var toggle = picker && picker.querySelector('[data-pb-variant-toggle]');
      if (toggle) toggle.setAttribute('aria-expanded', 'false');
    }
  }

  function pinVariantList(list, toggle) {
    var rect = toggle.getBoundingClientRect();
    var width = Math.max(rect.width, 148);
    var maxLeft = window.innerWidth - width - 8;
    var left = Math.min(Math.max(8, rect.left), Math.max(8, maxLeft));

    if (!list._originParent) list._originParent = list.parentNode;
    if (list.parentNode !== document.body) document.body.appendChild(list);

    list.hidden = false;
    list.style.position = 'fixed';
    list.style.left = Math.round(left) + 'px';
    list.style.width = Math.round(width) + 'px';
    list.style.maxHeight = '240px';
    list.style.zIndex = '100000';
    list.style.visibility = 'hidden';
    list.style.top = '0px';

    var height = list.offsetHeight;
    var below = rect.bottom + 8;
    var above = rect.top - 8 - height;
    var top = (below + height > window.innerHeight - 8 && above > 8) ? above : below;

    list.style.top = Math.round(top) + 'px';
    list.style.visibility = '';
  }

  document.addEventListener('click', function (evt) {
    var target = evt.target;
    if (!target || typeof target.closest !== 'function') return;

    var option = target.closest('[data-pb-variant-list] .pb-atc__variant-option');
    if (option) {
      evt.preventDefault();
      evt.stopPropagation();
      var list = option.closest('[data-pb-variant-list]');
      var picker = pickerForList(list);
      var options = list.querySelectorAll('.pb-atc__variant-option');
      for (var i = 0; i < options.length; i++) {
        options[i].classList.toggle('is-selected', options[i] === option);
        options[i].setAttribute('aria-selected', options[i] === option ? 'true' : 'false');
      }
      if (picker) applyVariantChoice(picker, option.getAttribute('data-value') || '', option.textContent.trim());
      closeVariantLists();
      return;
    }

    if (target.closest('[data-pb-variant-list]')) return;

    var toggle = target.closest('[data-pb-variant-toggle]');
    if (toggle) {
      evt.preventDefault();
      evt.stopPropagation();
      var picker = toggle.closest('[data-pb-variant-picker]');
      var list = picker.querySelector('[data-pb-variant-list]') ||
        document.querySelector('[data-pb-variant-list][data-pb-for="' + picker.getAttribute('data-pb-product') + '"]');
      if (!list) return;
      var willOpen = list.hidden;
      closeVariantLists();
      if (willOpen) {
        picker.classList.add('is-variant-open');
        toggle.setAttribute('aria-expanded', 'true');
        pinVariantList(list, toggle);
      }
      return;
    }

    closeVariantLists();
  });

  document.addEventListener('keydown', function (evt) {
    if (evt.key === 'Escape') closeVariantLists();
  });

  window.addEventListener('scroll', function (evt) {
    if (evt.target && evt.target.closest && evt.target.closest('[data-pb-variant-list]')) return;
    closeVariantLists();
  }, true);
  window.addEventListener('resize', function () { closeVariantLists(); });

  // Keep in step with the theme's own add-to-cart form and with the cart page.
  document.addEventListener('pb:cart-changed', loadCart);
  window.addEventListener('pageshow', function (evt) {
    if (evt.persisted) loadCart();
  });

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', loadCart);
  } else {
    loadCart();
  }
})();
